import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../Shared/Icon/Icon'

import ProductAnalyticsTierCompleted from './ProductAnalyticsTierCompleted'
import ProductAnalyticsTierStats from './ProductAnalyticsTierStats'

function ProductAnalyticsTierElement({
  tiersData, tierInfo, userInfo, tierRule, tabSwitch,
}) {
  const ruleInfo = tiersData.meta.tiers.find(info => info.rule === tierRule)
  const isActive = ruleInfo.requiredUserLevel === tierInfo.id

  return (
    <div className="col">
      <div className={`tiers-levels__card ${isActive ? 'is-active' : ''}`}>
        <h3 className="tiers-levels__title">
          {tierInfo.name}
          {tierInfo.reached === false
          && <Icon type={['far', 'lock']} color="grey-dark" className="locked" />
          }
        </h3>
        {tierInfo.reached === true ? (
          <ProductAnalyticsTierCompleted />
        ) : (
          <ProductAnalyticsTierStats tierInfo={tierInfo} userInfo={userInfo} isActive={isActive} tabSwitch={tabSwitch} />
        )}
      </div>
    </div>
  )
}

ProductAnalyticsTierElement.propTypes= {
  tiersData: PropTypes.object.isRequired,
  tierInfo: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  tabSwitch: PropTypes.func.isRequired,
  tierRule: PropTypes.number.isRequired,
}

export default ProductAnalyticsTierElement
